import { Tabs, TabsContent, TabsList, TabsTrigger } from '@neo/primitives/tabs'
import { usePermissions } from 'v2/shared/hooks/use-permissions'
import { TableWithSheetLayout } from 'v2/shared/layouts/table-with-sheet'
import { RbacModules, RbacPermissionTypes } from 'v2/types/rbac'
import { CallChannel } from '../channels/call'
import { SMSChannel } from '../channels/sms'
import { WhatsAppChannel } from '../channels/whatsapp'

export const ChannelSettings = () => {
  const { hasPermission } = usePermissions()

  const hasCallPermission = hasPermission(RbacModules.channelCalls, RbacPermissionTypes.view)
  const hasSMSPermission = hasPermission(RbacModules.channelMessage, RbacPermissionTypes.view)
  const hasWhatsAppPermission = hasPermission(RbacModules.channelWhatsapp, RbacPermissionTypes.view)

  // Determine default tab based on permissions
  const getDefaultTab = () => {
    if (hasCallPermission) return 'voice-call'
    if (hasSMSPermission) return 'sms'
    if (hasWhatsAppPermission) return 'whatsapp'
    return 'voice-call' // fallback
  }

  return (
    <TableWithSheetLayout title="Outbound Configuration" headerClassName="mb-4">
      <Tabs defaultValue={getDefaultTab()} className="flex flex-col flex-1 min-h-0">
        <TabsList variant="simple" className="mb-6">
          {hasCallPermission && (
            <TabsTrigger value="voice-call" variant="simple">
              Voice Call
            </TabsTrigger>
          )}
          {hasSMSPermission && (
            <TabsTrigger value="sms" variant="simple">
              SMS
            </TabsTrigger>
          )}
          {hasWhatsAppPermission && (
            <TabsTrigger value="whatsapp" variant="simple">
              WhatsApp
            </TabsTrigger>
          )}
        </TabsList>

        {hasCallPermission && (
          <TabsContent value="voice-call" className="flex-1 min-h-0">
            <CallChannel />
          </TabsContent>
        )}

        {hasSMSPermission && (
          <TabsContent value="sms" className="flex-1 min-h-0">
            <SMSChannel />
          </TabsContent>
        )}

        {hasWhatsAppPermission && (
          <TabsContent value="whatsapp" className="flex-1 min-h-0">
            <WhatsAppChannel />
          </TabsContent>
        )}
      </Tabs>
    </TableWithSheetLayout>
  )
}
